import { Settings as LayoutSettings } from '@ant-design/pro-layout';

const Settings: LayoutSettings & {
  pwa?: boolean;
  logo?: string;
  tabsLayout?: boolean;
} = {
  navTheme: 'light',
  headerTheme: 'light',
  headerHeight: 48,
  // 拂晓蓝
  primaryColor: '#1890FF',
  layout: 'mix',
  splitMenus: true,
  contentWidth: 'Fluid',
  fixedHeader: true,
  fixSiderbar: true,
  colorWeak: false,
  title: '生态智能助手',
  pwa: false,
  logo: '',
  iconfontUrl: '',
  tabsLayout: true,
};

export default Settings;
